import styled from 'styled-components/macro'

import { theme, fluidSystem, mediaShort } from 'styled'

export const Root = styled.div`
  ${fluidSystem};
  display: flex;
  align-items: center;

  ${mediaShort`
    padding-left: 40px;
  `};
`

export const QuestionList = styled.ul``

export const QuestionItem = styled.li`
  ${fluidSystem};
  position: relative;
  padding-left: 24px;
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
  }

  > * {
    opacity: ${({ selected }) => (selected ? 1 : 0)};
    transform: translate(${({ selected }) => (selected ? 0 : -100)}%, 0);
    transition: all 0.3s;
  }

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${theme.colors.primary};
    transform: translate(0, -50%);
    opacity: ${({ selected }) => (selected ? 1 : 0.25)};
    transition: opacity 0.3s;
  }
`
